export const COMPANY_OWNER  = 'company_owner';
export const COMPANY_MANAGER  = 'company_manager';
export const COMPANY_BOOK_MEETING_ROOMS = 'company_book_meeting_rooms';
export const COMPANY_BOOK_CO_WORKING_SPACES = 'company_book_co_working_spaces';
export const COMPANY_BOOK_EVENTS = 'company_book_events';
export const COMPANY_STANDARD_USER = 'company_standard_user';